module.exports = __webpack_public_path__ + "img/IMG_1231_L_Wood_MockedUp.40aec5ba.jpg";